import { SelectedProviders } from "@core/models/account/selected-providers.model";

export const SELECTED_PROVIDERS: SelectedProviders = {
    emailProvider: "Email Code",
    phoneProvider: "Phone Code"
}